import { render, staticRenderFns } from "./BonoAlacakFormWizard.vue?vue&type=template&id=5bfaeaf0"
import script from "./BonoAlacakFormWizard.vue?vue&type=script&lang=ts"
export * from "./BonoAlacakFormWizard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports